import constructMetaObject from './constructMetaObject'
import applyToOneOrMany from './applyToOneOrMany'

export default function transformBlogPost (data) {
	return applyToOneOrMany(_transformBlogPost, data)
}

function _transformBlogPost (post) {
	post.featuredImageUrl = post.featured_image ? post.featured_image.sizes.bandara_large : ''
	post.isVRBriefing = post.categories.indexOf(17) > -1 // 17 represents the VR Briefing category in wordpress

	// post.featuredImageAlt = post.title ? post.title : 'Blog Post Featured Image'
	return post
}



// WEBPACK FOOTER //
// ./src/api/util/transformBlogPost.js